import { render, staticRenderFns } from "./Readmore.vue?vue&type=template&id=400776c7&"
import script from "./Readmore.vue?vue&type=script&lang=js&"
export * from "./Readmore.vue?vue&type=script&lang=js&"
import style0 from "./Readmore.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports